exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-sucesso-index-js": () => import("./../../../src/pages/sucesso/index.js" /* webpackChunkName: "component---src-pages-sucesso-index-js" */)
}

